import React, { useMemo } from "react";

import { Grid } from "@material-ui/core";

import {
  ArrayField,
  Datagrid,
  DateField,
  NumberField,
  ResourceContextProvider,
  TextField,
} from "react-admin";

import { InventoryStatus } from "../../../utils/constants";
import { ShowInventoryButton } from "./ShowInventoryButton";

export const InventoriesPeak = ({ record, ...props }) => {
  const inventories = useMemo(() => {
    const list = record?.inventories?.items ?? [];
    const stored = list.filter((inv) => inv.status === InventoryStatus.STORED);
    const sorted = stored.sort((a, b) => {
      const dateA = new Date(a.receivedAt || 0);
      const dateB = new Date(b.receivedAt || 0);
      return dateA - dateB;
    });
    return { items: sorted };
  }, [record]);

  if (inventories.items.length === 0) return <></>;
  return (
    <ResourceContextProvider value="inventories">
      <Grid container>
        <Grid item xs={false} sm={1}>
          <></>
        </Grid>
        <Grid item xs={12} sm={10}>
          <ArrayField source="items" record={inventories} fullWidth>
            <Datagrid>
              <DateField source="receivedAt" label="Received" />
              <TextField source="lotNumber" label="Lot Number" />
              <TextField source="poNumber" label="PO Number" />
              <TextField source="railCarNumber" label="Car/Trl No." />
              <NumberField source="quantityOnHand" label="Qty. Stocked" />
              <NumberField source="quantityCommitted" label="Qty. Committed" />
              <ShowInventoryButton {...props} />,
            </Datagrid>
          </ArrayField>
        </Grid>
        <Grid item xs={false} sm={1}>
          <></>
        </Grid>
      </Grid>
    </ResourceContextProvider>
  );
};
